export interface TellUsAboutYourselfData {
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  birthDate: any;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: any;
  zipCode: string;
  phoneNumber: string;
  ssnNumber: string;
  email: string;
  preferredName: string;
}

export const TellUsAboutYourselfEmptyData: TellUsAboutYourselfData = {
  firstName: "",
  middleName: "",
  lastName: "",
  suffix: "",
  birthDate: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: 0,
  zipCode: "",
  phoneNumber: "",
  ssnNumber: "",
  email: "",
  preferredName: ""
}

export interface EmploymentDetailsData {
  incomeSource: number,
  occupation: number,
  employerCountry: number,
  annualIncome: number
}

export const EmploymentDetailsEmptyData: EmploymentDetailsData = {
  incomeSource: 0,
  occupation: 0,
  employerCountry: 0,
  annualIncome: 0
}
